import React, { useEffect, useState, useRef } from 'react'
import { Navigate } from 'react-router-dom'
import useAuthStore from '../stores/authStore'

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, checkAuthStatus, isLoading } = useAuthStore()
  const [isChecking, setIsChecking] = useState(true)
  const hasChecked = useRef(false)

  useEffect(() => {
    // Only check once on mount to prevent infinite loops
    if (hasChecked.current) return
    
    // Always verify with Cognito, not just localStorage
    const verifyAuth = async () => {
      hasChecked.current = true
      setIsChecking(true)
      await checkAuthStatus()
      setIsChecking(false)
    }
    verifyAuth()
  }, []) // Empty dependency array - only run once on mount

  // Show loading while checking authentication
  if (isChecking || isLoading) {
    return (
      <div className="h-screen w-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="w-8 h-8 border-4 border-green-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600">Verifying authentication...</p>
        </div>
      </div>
    )
  }

  // Only render children if authenticated (verified with Cognito)
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  return children
}

export default ProtectedRoute

